"use strict";

/* removed: var _$utils_25 = require("./../utils"); */;

var _$transformData_14 = function (data, headers, fns) {
  return _$utils_25.forEach(fns, function (fn) {
    data = fn(data, headers);
  }), data;
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRyYW5zZm9ybURhdGEuanMiXSwibmFtZXMiOlsibW9kdWxlIiwiZGF0YSIsImhlYWRlcnMiLCJmbnMiLCJ1dGlscyIsImZvckVhY2giLCJmbiJdLCJtYXBwaW5ncyI6IkFBQUEsWUFBQSxDQUFBOztBQUVBLHVEQUFBOztBQVVBQSxzQkFBQUEsR0FBaUIsVUFBdUJDLElBQXZCLEVBQTZCQyxPQUE3QixFQUFzQ0MsR0FBdEMsRUFBc0NBO0VBTXJELE9BSkFDLFVBQUFBLENBQU1DLE9BQU5ELENBQWNELEdBQWRDLEVBQW1CLFVBQW1CRSxFQUFuQixFQUFtQkE7SUFDcENMLElBQUFBLEdBQU9LLEVBQUFBLENBQUdMLElBQUhLLEVBQVNKLE9BQVRJLENBQVBMLENBQUFBO0dBREZHLENBQUFBLEVBSU9ILElBQVAsQ0FBQTtDQU5GRCxDQUFBQSIsInNvdXJjZXNDb250ZW50IjpbbnVsbF19